goog.provide("shadow.js.shim.module$src$svg$objects$book_open_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$book_open_svg");
shadow.js.shim.module$src$svg$objects$book_open_svg = shadow.js.nativeProvides["src/svg/objects/book-open.svg"] = shadow$bridge("src/svg/objects/book-open.svg");
module$shadow_js_shim_module$src$svg$objects$book_open_svg.default = shadow.js.shim.module$src$svg$objects$book_open_svg;
